import CustomTab from "components/CustomTab";
import { ERR_NETWORK } from "constants/messages";
import { modifyArray } from "lib/arrayObject";
import { serverGet, serverPost } from "lib/serverRequest";
import { useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";
import QueueTable from "./QueueTable";

export default function QueueComponent() {
  const { enqueueSnackbar } = useSnackbar();
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState({
    label: "Pending",
    tab: "0",
  });

  const loadData = () => {
    openLoading(true);
    serverGet({
      url: "queue",
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setData(res);
      },
    });
  };

  const handleClickInvite = (row) => {
    openLoading(true);
    serverPost({
      url: "queue/invite",
      data: { data: row },
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        if (Boolean(res.checkFlag)) {
          enqueueSnackbar(res.message, {
            variant: "success",
          });
          const findIndex = data?.findIndex((item) => item.id === row.id);
          setData((s = []) => modifyArray(s, findIndex, res));
        } else {
          enqueueSnackbar(res.message, {
            variant: "warning",
          });
        }
      },
    });
  };

  useEffect(() => {
    loadData();
    //eslint-disable-next-line
  }, []);

  return (
    <div>
      <CustomTab
        tabs={[
          { label: "Pending", tab: "0" },
          { label: "Sent", tab: "1" },
          { label: "Expired", tab: "2" },
        ]}
        activeTab={activeTab}
        onClick={(tab) => setActiveTab(tab)}
      />
      <QueueTable
        tab={activeTab?.tab ?? "0"}
        data={data?.filter((item) => item?.status === activeTab.tab)}
        onClick={handleClickInvite}
      />
    </div>
  );
}
